export const JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD = 15;
export const PUNCH_CLOCK_OUT_TIME_PICKER_INTERVAL_PERIOD = 15;
export const BREAKS_TIME_PICKER_INTERVAL_PERIOD = 5;